import isEmpty from 'lodash/isEmpty'
import isFunction from 'lodash/isFunction'
import isString from 'lodash/isString'
import invariant from 'invariant'
import warning from 'warning'
import createRootReducer from '../reducers'

/**
 * Wrapper to cache reference to store
 * @param store
 * @returns {injectReducer}
 */
export function injectAsyncReducer (store) {
  /**
   * Append a new slice to the root reducer
   * @param {string} name
   * @param {function} reducer
   * @return {void}
   */
  return function injectReducer (name, asyncReducer) {
    invariant(
      isString(name) && !isEmpty(name) && isFunction(asyncReducer),
      '(app/utils...) injectAsyncReducer: Expected `asyncReducer` to be a reducer function'
    )

    // Ignore if this part of the store already exists
    if (Reflect.has(store.asyncReducers, name)) return

    store.asyncReducers[name] = asyncReducer // eslint-disable-line no-param-reassign
    store.replaceReducer(createRootReducer(store.asyncReducers))
  }
}

/**
 * @param store
 * @returns {injectSagas}
 * @return {void}
 */
export function injectAsyncSagas (store) {
  /**
   * Add saga's to store middleware
   * @param {array} sagas
   */
  return function injectSagas (sagas) {
    invariant(
      Array.isArray(sagas),
      '(app/utils...) injectAsyncSagas: Expected `sagas` to be an array of generator functions'
    )

    warning(
      !isEmpty(sagas),
      '(app/utils...) injectAsyncSagas: Received an empty `sagas` array'
    )

    sagas.map(store.runSaga)
  }
}

/**
 * Wrapper to cache reference to store
 * @param store
 * @returns {{injectReducer: injectReducer, injectSagas: void}}
 */
export default function (store) {
  return {
    injectReducer: injectAsyncReducer(store),
    injectSagas: injectAsyncSagas(store)
  }
}
